import { usePadding } from "components/modules/Editors/MemeGenerator/Preview/Paddings/usePadding";
import { PaddingType } from "store/features/memeGenerator/types/padding";

interface PaddingBottomProps {
    xRatio: number;
    yRatio: number;
}

export const PaddingBottom = ({xRatio, yRatio}: PaddingBottomProps) => {
    const { padding, color } = usePadding(PaddingType.BOTTOM);
    if (!padding) return null;
    return (
        <div
            className="absolute"
            style={{
                left: padding.left * xRatio,
                top: padding.top * yRatio,
                width: padding.width * xRatio,
                height: padding.height * yRatio,
                backgroundColor: color.color,
            }}
        />
    );
};
